module.exports = __webpack_public_path__ + "img/logout.e9b8417b.svg";